import { schema } from 'normalizr';

// Seasons dont have ID. Using seriesId_seasonsNumber
// eslint-disable-next-line no-unused-vars
const getSeassonId = (val, par, k) => `serie_${par._id}___season_${val.number}`;

// eslint-disable-next-line no-unused-vars
const processEpisode = (value, season, key) => {
  const { serieId, serieSlug, seassonId } = season;
  return {
    ...value,
    serieId,
    serieSlug,
    seassonId,
  };
};

const processSeason = (value, parent, key) => {
  const serieId = parent._id;
  const serieSlug = parent.slug;
  const serieName = parent.name;
  const seassonId = getSeassonId(value, parent, key);
  return {
    ...value,
    serieId,
    serieSlug,
    serieName,
    seassonId,
  };
};

export const VodEpisodeSchema = new schema.Entity(
  'vodEpisodes',
  {},
  { idAttribute: '_id', processStrategy: processEpisode },
);

export const VodSeasonSchema = new schema.Entity(
  'vodSeasons',
  { episodes: [VodEpisodeSchema] },
  { idAttribute: getSeassonId, processStrategy: processSeason },
);

export const VodContentSchema = new schema.Entity(
  'vodContent',
  { seasons: [VodSeasonSchema] },
  { idAttribute: '_id' },
);

export const VodCategorySchema = new schema.Entity(
  'vodCategories',
  { items: [VodContentSchema] },
  { idAttribute: '_id' },
);
